import React from "react";
import { Breaker, Button, Flexbox, InputField } from "../../Theme/GlobalStyles";
import { Text } from "../../Theme/Typography";
import { CloseCircle } from "../../Theme/Icons";
import { globalTheme } from "../../Theme/Theme";
import { PopupBody, PopupWrapper } from "./CommonPopup";

const EditUserPopup = ({
  isActive,
  onClickUpdateUser,
  onClickClosePopup,
  onChangeFormData,
  errors = {},
  isEditUserPopupFetching,
  formData = {},
}) => {
  return (
    <PopupWrapper className={`${isActive ? "active" : ""}`}>
      <PopupBody maxWidth={560} maxHeight={600}>
        <Flexbox spaceBW alignCenter>
          <Text font18 inter semiBold white maxWidth="max-content">
            Edit User
          </Text>
          <CloseCircle className={"pointer"} onClick={onClickClosePopup} />
        </Flexbox>

        <Breaker marginTop={16} marginBottom={20} borderColor={globalTheme.colors.white1} />

        <Flexbox column gap={20}>
          <InputField
            name="firstName"
            label="First Name"
            placeholder="Enter First Name"
            onChange={onChangeFormData}
            value={formData.firstName}
            error={errors.firstName}
          />
          <InputField
            name="lastName"
            label="Last Name"
            placeholder="Enter Last Name"
            onChange={onChangeFormData}
            value={formData.lastName}
          />
          <InputField
            name="uidNumber"
            label="UID"
            placeholder="Enter UID"
            onChange={onChangeFormData}
            value={formData.uidNumber}
          />
          <InputField
            name="officialEmail"
            label="Official Email"
            placeholder="Enter Official Email"
            onChange={onChangeFormData}
            value={formData.officialEmail}
            error={errors.officialEmail}
          />
          <InputField
            name="mobileNumber"
            label="Phone No"
            placeholder="Enter Phone No"
            onChange={onChangeFormData}
            value={formData.mobileNumber}
            error={errors.mobileNumber}
          />
        </Flexbox>

        <Flexbox alignCenter gap={12} justiCenter className="mt20">
          <Button
            buttonMd
            whiteFilled
            name="Cancel"
            disabled={isEditUserPopupFetching}
            onClick={onClickClosePopup}
          />
          <Button
            buttonMd
            primaryFilled
            name="Update"
            isCalling={isEditUserPopupFetching}
            disabled={isEditUserPopupFetching}
            onClick={onClickUpdateUser}
          />
        </Flexbox>
      </PopupBody>
    </PopupWrapper>
  );
};

export default EditUserPopup;
